var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _b;
import { createSlice, } from '@reduxjs/toolkit';
import { LANGUAGES } from "../../../../constants";
export var initialChatState = {
    messages: [],
    categories: [],
    isUserResponseLoading: false,
    isResponseLoading: false,
    isLeadGenerationSubmitted: false,
    sessionId: '',
    language: LANGUAGES.EN,
    leadGenerationData: {},
    answerReport: {}
};
var chatSlice = createSlice({
    name: 'CHAT',
    initialState: initialChatState,
    reducers: {
        sendMessage: function (state, _b) {
            var payload = _b.payload;
            state.messages = __spreadArray(__spreadArray([], state.messages, true), [payload], false);
        },
        setIsResponseLoading: function (state, _b) {
            var payload = _b.payload;
            state.isResponseLoading = payload;
        },
        setIsUserResponseLoading: function (state, _b) {
            var payload = _b.payload;
            state.isUserResponseLoading = payload;
        },
        setIsLeadGenerationSubmitted: function (state, _b) {
            var payload = _b.payload;
            state.isLeadGenerationSubmitted = payload;
        },
        setLeadGenerationData: function (state, _b) {
            var payload = _b.payload;
            state.leadGenerationData = payload;
        },
        setSessionId: function (state, _b) {
            var payload = _b.payload;
            state.sessionId = payload;
        },
        setCategories: function (state, _b) {
            var payload = _b.payload;
            state.categories = payload;
        },
        setLanguage: function (state, _b) {
            var payload = _b.payload;
            state.language = payload;
        },
        updateResponseMessage: function (state, _b) {
            var payload = _b.payload;
            state.messages[payload.index] = payload.data;
        },
        setAnswerReport: function (state, _b) {
            var payload = _b.payload;
            state.answerReport = payload;
        },
    },
});
export var sendMessage = (_b = chatSlice.actions, _b.sendMessage), setIsResponseLoading = _b.setIsResponseLoading, setIsUserResponseLoading = _b.setIsUserResponseLoading, setLeadGenerationData = _b.setLeadGenerationData, setIsLeadGenerationSubmitted = _b.setIsLeadGenerationSubmitted, setSessionId = _b.setSessionId, setCategories = _b.setCategories, setLanguage = _b.setLanguage, updateResponseMessage = _b.updateResponseMessage, setAnswerReport = _b.setAnswerReport;
export var getAllMessages = function (state) { return state.chat.messages; };
export var isResponseLoading = function (state) { return state.chat.isResponseLoading; };
export var isUserResponseLoading = function (state) { return state.chat.isUserResponseLoading; };
export var getLeadGenerationData = function (state) { return state.chat.leadGenerationData; };
export var isLeadGenerationSubmitted = function (state) { return state.chat.isLeadGenerationSubmitted; };
export var getAnswerReport = function (state) { return state.chat.answerReport; };
export var currentSessionId = function (state) { return state.chat.sessionId; };
export var currentLanguage = function (state) { return state.chat.language; };
export var getCategories = function (state) { return state.chat.categories; };
export default chatSlice.reducer;
